import { Component, ElementRef, Input, OnDestroy, OnInit, TemplateRef } from "@angular/core";
import { ScrollService } from "@merri/common";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { EventContextService } from "src/app/features/events";
import { VendorBasic } from "src/app/features/vendors";
import { VisionboardCategoriesService } from "../../../services";
import { VisionboardItemAddRemoveButtonService } from "../../services";
import { ForceVisionboardItemAddRemoveButton } from "../visionboard-item-add-remove-button/visionboard-item-add-remove-button.component";

@Component({
    selector: "app-visionboard-item-selection-panel",
    templateUrl: "./visionboard-item-selection-panel.component.html",
    styleUrls: ["./visionboard-item-selection-panel.component.scss"],
    providers: [VisionboardItemAddRemoveButtonService],
    standalone: false
})
export class VisionboardItemSelectionPanelComponent implements OnInit, OnDestroy {
  private _destroyed$: Subject<void> = new Subject<void>();
  preferredVendor: VendorBasic;

  subCategoryName: string;
  scrollerLoaded: boolean;

  @Input() disableDrag: boolean;
  @Input() forceVisionboardItemAddRemoveButton: ForceVisionboardItemAddRemoveButton;
  @Input() itemCustomAddRemoveTemplate: TemplateRef<void>;
  @Input() source: string;

  constructor(
    private _visionboardCategoriesService: VisionboardCategoriesService,
    private _element: ElementRef,
    private _scrollService: ScrollService,
    private _eventContextService: EventContextService,
  ) {}

  ngOnInit(): void {
    this._visionboardCategoriesService.selectedCategory$.pipe(takeUntil(this._destroyed$)).subscribe({
      next: category => {
        this.subCategoryName = category && category[1].name;
        this.preferredVendor = this._eventContextService.isUserEvent() && category && category[1].preferredVendor;
      },
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  onCloseButtonClick(): void {
    this._visionboardCategoriesService.setSelectedCategory(null);
  }

  onItemResultsPaged(): void {
    const nElement = this._element.nativeElement as HTMLElement;

    if (nElement) {
      setTimeout(() => {
        this._scrollService.scrollToTopOfElement(nElement.parentElement);
        this._scrollService.scrollToTopOfElement(window, false);
      }, 100);
    }
  }

  onScrollerLoaded(): void {
    this.scrollerLoaded = true;
  }
}
